import { useState } from 'react';
import './App.css';

const LOGO_URL =
  'https://iaorixerxnqedwgkqxtz.supabase.co/storage/v1/object/public/logo/INGO%20RIDE_020840_page-0001.jpg';

const PHONE_SCREEN_URL =
  'https://iaorixerxnqedwgkqxtz.supabase.co/storage/v1/object/public/logo/WhatsApp%20Image%202026-05-19%20at%205.19.15%20PM.jpeg';

const PHONE_SCREEN_HOME_URL =
  'https://iaorixerxnqedwgkqxtz.supabase.co/storage/v1/object/public/logo/WhatsApp%20Image%202026-05-19%20at%205.19.27%20PM.jpeg';

const PHONE_SCREEN_SHOPS_URL =
  'https://iaorixerxnqedwgkqxtz.supabase.co/storage/v1/object/public/logo/WhatsApp%20Image%202026-05-19%20at%205.19.49%20PM.jpeg';

const APP_STORE_BADGE_URL =
  'https://iaorixerxnqedwgkqxtz.supabase.co/storage/v1/object/public/logo/images.png';

const GOOGLE_PLAY_BADGE_URL =
  'https://iaorixerxnqedwgkqxtz.supabase.co/storage/v1/object/public/logo/ldAb_E9IiDEg3fgYQZz_F4mqwSeitd76CA.png';

const services = [
  {
    icon: '📦',
    title: 'Package Delivery',
    description:
      'Send packages anywhere in the city. Fast, safe and affordable door to door delivery with real time tracking',
    features: [
      'Real-time tracking',
      'Proof of delivery',
      'Package insurance',
      'Same day delivery',
    ],
  },
  {
    icon: '🚕',
    title: 'Ride Hailing',
    description:
      'Book a bike, tuk-tuk or taxi in minutes. Safe, affordable rides with verified drivers',
    features: [
      'Bike, Tuk-Tuk & Taxi',
      'Upfront pricing',
      'Verified drivers',
      'In-app navigation',
    ],
    popular: true,
  },
  {
    icon: '🛍️',
    title: 'Shop & Deliver',
    description:
      'Order from local shops, pharmacies and restaurants. Get it delivered fast right to your door',
    features: [
      'Local shops & restaurants',
      'Grocery delivery',
      'Pharmacy orders',
      'Cash on delivery',
    ],
  },
];

const appFeatures = [
  ['Real-Time GPS Tracking', 'Watch your delivery move live on the map'],
  ['Instant Notifications', 'SMS, WhatsApp and push alerts at every step'],
  ['Multiple Payment Options', 'EcoCash, card, cash or InGo wallet'],
  ['In-App Chat & Calls', 'Talk directly to your driver anytime'],
];

const testimonials = [
  {
    quote:
      'InGo has completely changed how I send packages. Fast, reliable and always on time. Highly recommend to any business owner',
    name: 'Sarah M.',
    role: 'Small Business Owner',
  },
  {
    quote:
      'The app is so easy to use. I booked a ride in under a minute and the driver was at my door in 8 minutes. Amazing service',
    name: 'James K.',
    role: 'Regular Customer',
    featured: true,
  },
  {
    quote:
      'As a driver I love the earnings dashboard. I can track exactly what I make each day. InGo treats its drivers well',
    name: 'David T.',
    role: 'InGo Driver Partner',
  },
];

const deliveryTypes = [
  ['🏍️', 'Standard', '45-60 mins', 'Most affordable option for regular deliveries'],
  ['⚡', 'Express', '20-30 mins', 'Fastest delivery for urgent packages', 'Popular'],
  ['🕒', 'Scheduled', 'Your chosen time', 'Plan ahead and schedule your delivery in advance'],
];

const deliveryFeatures = [
  'Real-time GPS tracking',
  'Proof of delivery photo',
  'In-app driver chat',
  'Package insurance available',
  'Multiple stop deliveries',
  'Cash on delivery option',
  'Delivery to any address',
  'Instant SMS notifications',
];

const vehicleOptions = [
  ['🛺', 'Tuk-Tuk', '1-2 passengers', ['Fast', 'Affordable', 'Short trips']],
  ['🚗', 'Standard Taxi', '1-4 passengers', ['Comfortable', 'AC', 'City rides']],
  ['🚘', 'Premium Taxi', '1-4 passengers', ['Luxury', 'Top rated', 'Business']],
];

const shopCategories = [
  ['🛒', 'Groceries', 'Fresh daily'],
  ['🍔', 'Restaurants', 'Hot meals'],
  ['💊', 'Pharmacy', 'Health essentials'],
  ['💻', 'Electronics', 'Gadgets & more'],
  ['👕', 'Clothing', 'Fashion delivered'],
  ['＋', 'More Shops', 'Browse all'],
];

const navLinks = [
  ['Home', '/'],
  ['Services', '/?page=services'],
  ['About Us', '/?page=about'],
  ['Contact', '/?page=contact'],
];

const businessSolutions = [
  {
    icon: '🏪',
    title: 'For Shop Owners',
    description:
      'List your business on InGo and reach thousands of local customers every day. We handle the delivery, you focus on your products',
    stats: ['80+ shops listed', '500+ daily orders', 'Weekly payouts'],
    benefits: [
      'Free shop registration',
      'Easy product management',
      'Delivery handled by InGo',
      'Sales analytics dashboard',
      'Direct customer chat',
      'Weekly earnings payout',
    ],
    action: 'Register Your Shop',
  },
  {
    icon: '🏍️',
    title: 'For Drivers',
    description:
      'Join InGo as a delivery driver or taxi partner. Set your own hours, earn daily and be part of a growing community of InGo driver partners',
    stats: ['250+ active drivers', 'Daily earnings', 'Flexible hours'],
    benefits: [
      'Flexible working hours',
      'Daily earnings tracker',
      'Navigation assistance',
      'Driver support team',
      'Performance bonuses',
      'Community of drivers',
    ],
    action: 'Become a Driver',
  },
];

const faqs = [
  ['Are there any hidden fees?', 'No. You see the base fare, distance cost and any express fee before confirming.'],
  ['How is the fare calculated?', 'Fares are based on service type, distance, traffic, demand and time of day.'],
  ['Can I pay with cash?', 'Yes. InGo supports cash, card, EcoCash and InGo wallet payments.'],
  ['What if my order is late?', 'You can track it live, chat with the driver and contact support directly in the app.'],
  ['Is my package insured?', 'Package insurance is available for eligible deliveries at checkout.'],
];

const aboutTimeline = [
  ['2024', 'InGo founded. First delivery made in the city'],
  ['2024', '500 drivers onboarded. First 10,000 deliveries completed'],
  ['2025', 'Expanded to 5 cities. Launched ride hailing service'],
  ['2025', 'Launched shop & delivery. Partnered with 50+ local shops'],
  ['2026', 'Now operating in 3+ cities with 5,000+ happy customers'],
];

const values = [
  ['⚡', 'Speed', 'We obsess over delivery times. Fast service is not a bonus, it is our standard promise to every customer'],
  ['🛡️', 'Trust & Safety', 'Every driver is verified. Every package is tracked. Every ride is safe. We never compromise on your safety'],
  ['♥', 'Customer First', 'Everything we build starts with our customers. Your experience drives every decision we make at InGo'],
  ['🌍', 'Community', 'We support local drivers and shop owners. When InGo grows the whole community around us grows with it'],
  ['🍃', 'Affordability', 'Quality service should not cost a fortune. We keep our prices fair and transparent for everyone always'],
  ['📈', 'Innovation', 'We constantly improve our platform using technology to make logistics smarter faster and more efficient every day'],
];

const contactCards = [
  ['☎', 'Call Us', '+263 77 123 4567', 'Mon-Fri 8am-6pm', 'Call Now'],
  ['✉', 'Email Us', 'hello@ingo.app', 'We reply within 24 hours', 'Send Email'],
  ['☘', 'WhatsApp Us', '+263 77 123 4567', 'Quick responses on WhatsApp', 'Message Us'],
];

const contactFaqs = [
  ['How do I track my delivery?', 'Open the InGo app, select your active order and follow the live map until it arrives.'],
  ['What areas do you cover?', 'InGo currently operates in 3+ cities, with new neighborhoods added regularly.'],
  ['How do I become a driver?', 'Apply through the driver form, complete verification and attend onboarding before your first trip.'],
  ['What payment methods accepted?', 'We accept cash, card, EcoCash and InGo wallet payments depending on your city.'],
  ['How do I register my shop?', 'Submit your shop details through our partner form and our team will help set up your catalogue.'],
  ['What if my package is lost?', 'Contact support immediately. Eligible packages can be reviewed for insurance coverage.'],
  ['How are drivers verified?', 'Drivers complete identity checks, license review, vehicle inspection and ongoing ratings review.'],
  ['Can I cancel my order?', 'Yes, you can cancel before a driver starts the trip. Some late cancellations may include a fee.'],
];

function DownloadBadge({ store }) {
  const isGooglePlay = store === 'Google Play';

  return (
    <a
      className="download-badge"
      href="#download"
      aria-label={isGooglePlay ? 'Get it on Google Play' : 'Download on the App Store'}
    >
      <img
        src={isGooglePlay ? GOOGLE_PLAY_BADGE_URL : APP_STORE_BADGE_URL}
        alt={isGooglePlay ? 'Get it on Google Play' : 'Download on the App Store'}
      />
    </a>
  );
}

function PhoneMockup({ variant = 'home', screenSrc = PHONE_SCREEN_URL, screenAlt = 'InGo app screen' }) {
  return (
    <div className={`phone-mockup ${variant}`}>
      <div className="phone-speaker" />
      <div className="phone-screen">
        <img className="phone-screen-image" src={screenSrc} alt={screenAlt} />
      </div>
    </div>
  );
}

function BrandLogo({ className = 'logo' }) {
  return (
    <a className={className} href="/" aria-label="InGo home">
      <img src={LOGO_URL} alt="InGo Ride" />
    </a>
  );
}

function SiteNav({ activePage = 'Home', actionHref = '#download' }) {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className={`navbar ${menuOpen ? 'menu-open' : ''}`}>
      <BrandLogo />
      <button
        className="nav-toggle"
        type="button"
        aria-expanded={menuOpen}
        aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'}
        onClick={() => setMenuOpen((isOpen) => !isOpen)}
      >
        <span />
        <span />
        <span />
      </button>
      <div className="nav-links" aria-label="Primary navigation">
        {navLinks.map(([label, href]) => (
          <a className={label === activePage ? 'active' : undefined} href={href} key={label}>
            {label}
          </a>
        ))}
      </div>
      <div className="nav-actions">
        <a className="btn btn-primary" href={actionHref}>
          Download App
        </a>
      </div>
    </nav>
  );
}

function ServicesPage() {
  return (
    <div className="ingo-site">
      <SiteNav activePage="Services" actionHref="#services-cta" />

      <main className="services-page">
        <section className="services-hero section-reveal">
          <div className="eyebrow-pill">Everything in one place</div>
          <h1>Our Services</h1>
          <p>
            From package delivery to rides and local shopping, InGo has
            everything you need in one app
          </p>
          <div className="breadcrumb">
            <a href="/">Home</a>
            <span>›</span>
            <span>Services</span>
          </div>
        </section>

        <section className="service-detail section section-reveal">
          <div className="service-copy">
            <span className="service-pill">DELIVERY</span>
            <h2>Fast & Reliable Package Delivery</h2>
            <p>
              Send packages anywhere in the city within 45 minutes. Our verified
              drivers handle your packages with care every time
            </p>

            <div className="delivery-type-grid">
              {deliveryTypes.map(([icon, title, time, copy, badge]) => (
                <article className={`delivery-type-card ${badge ? 'highlight' : ''}`} key={title}>
                  {badge && <span className="popular-badge">{badge}</span>}
                  <div className="mini-icon">{icon}</div>
                  <h3>{title}</h3>
                  <strong>{time}</strong>
                  <p>{copy}</p>
                </article>
              ))}
            </div>

            <div className="check-grid">
              {deliveryFeatures.map((feature) => (
                <span key={feature}>✓ {feature}</span>
              ))}
            </div>

            <a className="btn btn-primary btn-large" href="#services-cta">
              Book a Delivery
            </a>
          </div>

          <div className="service-visual">
            <PhoneMockup variant="tracking" />
            <div className="metric-card">
              <strong>45 min</strong>
              <small>Average delivery time</small>
            </div>
          </div>
        </section>

        <section className="service-detail service-detail-reverse section section-reveal">
          <div className="service-visual ride-visual">
            <PhoneMockup variant="services" />
            {[
              ['🛺', 'Tuk-Tuk'],
              ['🚗', 'Standard'],
              ['🚘', 'Premium'],
            ].map(([icon, title], index) => (
              <div className={`vehicle-float vehicle-${index + 1}`} key={title}>
                <span>{icon}</span>
                <div>
                  <strong>{title}</strong>
                </div>
              </div>
            ))}
          </div>

          <div className="service-copy">
            <span className="service-pill">RIDES</span>
            <h2>Affordable Rides Anytime Anywhere</h2>
            <p>
              Book a tuk-tuk, standard or premium taxi in minutes. All drivers
              are verified and rated by thousands of customers
            </p>

            <div className="vehicle-list">
              {vehicleOptions.map(([icon, title, seats, tags]) => (
                <article className="vehicle-row" key={title}>
                  <span className="mini-icon">{icon}</span>
                  <div>
                    <h3>{title}</h3>
                    <small>{seats}</small>
                    <div className="tag-row">
                      {tags.map((tag) => (
                        <span key={tag}>{tag}</span>
                      ))}
                    </div>
                  </div>
                </article>
              ))}
            </div>

            <div className="safety-card">
              <span className="mini-icon">🛡️</span>
              <div>
                <h3>Your Safety is Our Priority</h3>
                <ul>
                  {[
                    'All drivers verified & licensed',
                    'Vehicle inspections required',
                    'In-app SOS emergency button',
                    'Share trip with contacts',
                    'Rated after every ride',
                  ].map((item) => (
                    <li key={item}>✓ {item}</li>
                  ))}
                </ul>
              </div>
            </div>

            <a className="btn btn-primary btn-large" href="#services-cta">
              Book a Ride
            </a>
          </div>
        </section>

        <section className="service-detail section section-reveal">
          <div className="service-copy">
            <span className="service-pill">SHOPPING</span>
            <h2>Shop Local, Delivered Fast</h2>
            <p>
              Order from hundreds of local shops, pharmacies, grocery stores and
              restaurants. Get everything delivered to your door in under an hour
            </p>

            <div className="category-grid">
              {shopCategories.map(([icon, title, copy]) => (
                <article className="category-card" key={title}>
                  <span>{icon}</span>
                  <h3>{title}</h3>
                  <small>{copy}</small>
                </article>
              ))}
            </div>

            <div className="process-steps">
              {['Browse shops & products', 'Add to cart & checkout', 'Track delivery live'].map(
                (step, index) => (
                  <div key={step}>
                    <strong>{index + 1}</strong>
                    <span>{step}</span>
                  </div>
                )
              )}
            </div>

            <a className="btn btn-primary btn-large" href="#services-cta">
              Start Shopping
            </a>
          </div>

          <div className="service-visual shopping-visual">
            <PhoneMockup variant="services" />
            <div className="order-card">
              <span>Delivering Now</span>
              <small>14 Market Street</small>
              <strong>ETA 12 mins</strong>
            </div>
          </div>
        </section>

        <section className="section business-solutions section-reveal">
          <div className="section-heading">
            <h2>Solutions for Business</h2>
            <p>
              Grow your shop, earn as a driver, and serve your city with InGo's
              local commerce network.
            </p>
          </div>
          <div className="solution-grid">
            {businessSolutions.map((solution) => (
              <article className="solution-card" key={solution.title}>
                <div className="solution-banner">{solution.icon}</div>
                <h3>{solution.title}</h3>
                <p>{solution.description}</p>
                <div className="solution-stats">
                  {solution.stats.map((stat) => (
                    <strong key={stat}>{stat}</strong>
                  ))}
                </div>
                <ul>
                  {solution.benefits.map((benefit) => (
                    <li key={benefit}>✓ {benefit}</li>
                  ))}
                </ul>
                <a className="btn btn-primary" href="#contact">
                  {solution.action}
                </a>
              </article>
            ))}
          </div>
        </section>

        <section className="section pricing-section section-reveal">
          <div className="section-heading">
            <span>FAQ</span>
            <h2>Frequently Asked Questions</h2>
            <p>Helpful answers about using InGo services</p>
          </div>
          <div className="faq">
            {faqs.map(([question, answer], index) => (
              <details key={question} open={index === 0}>
                <summary>
                  {question}
                  <span>⌄</span>
                </summary>
                <p>{answer}</p>
              </details>
            ))}
          </div>
        </section>

        <section id="services-cta" className="services-cta section-reveal">
          <h2>Ready to Get Started?</h2>
          <p>Download the InGo app and get your first delivery free</p>
          <div className="cta-row">
            <a className="btn white-btn" href="#download">
              Download App
            </a>
            <a className="btn white-outline-btn" href="#contact">
              Contact Sales
            </a>
          </div>
        </section>
      </main>

      <footer id="contact" className="footer">
        <div className="footer-grid">
          <div>
            <BrandLogo className="footer-logo" />
            <p>Deliver. Ride. Shop.</p>
            <div className="socials">
              {['f', 'ig', 'x', 'in'].map((social) => (
                <a href="#contact" key={social} aria-label={social}>
                  {social}
                </a>
              ))}
            </div>
          </div>
          {[
            ['Company', 'About Us', 'Careers', 'Press', 'Blog'],
            ['Services', 'Package Delivery', 'Ride Hailing', 'Shop & Deliver', 'Business Solutions'],
            ['Support', 'Help Center', 'Contact Us', 'Privacy Policy', 'Terms of Service'],
          ].map(([heading, ...links]) => (
            <div className="footer-column" key={heading}>
              <h3>{heading}</h3>
              {links.map((link) => (
                <a href="#contact" key={link}>
                  {link}
                </a>
              ))}
            </div>
          ))}
        </div>
        <div className="footer-bottom">
          <span>© 2026 InGo. All rights reserved</span>
          <span>Made with ❤️ in Africa</span>
        </div>
      </footer>
    </div>
  );
}

function AboutPage() {
  return (
    <div className="ingo-site">
      <SiteNav activePage="About Us" actionHref="#about-cta" />

      <main className="about-page">
        <section className="about-hero section-reveal">
          <div className="about-hero-copy">
            <div className="eyebrow-pill">Our Story</div>
            <h1>We Are InGo</h1>
            <p>
              On a mission to make delivery, rides and shopping fast,
              affordable and accessible for everyone in Africa
            </p>
            <div className="stat-pills">
              <span>Founded 2024</span>
              <span>Operating in 3+ Cities</span>
            </div>
            <div className="breadcrumb">
              <a href="/">Home</a>
              <span>›</span>
              <span>About Us</span>
            </div>
          </div>
          <div className="about-illustration">
            <div className="city-card">
              <img
                src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=900&q=80"
                alt="InGo team collaborating in the city"
              />
              <div>
                <strong>City delivery network</strong>
                <small>Drivers, shops and customers connected in real time</small>
              </div>
            </div>
          </div>
        </section>

        <section className="story-section section section-reveal">
          <div className="story-copy">
            <span className="section-kicker">OUR STORY</span>
            <h2>Born from a Simple Idea</h2>
            <p>
              InGo was founded in 2024 with one simple goal: make it easy for
              anyone to send a package, book a ride or order from a local shop
              using one simple app
            </p>
            <p>
              We saw how difficult and expensive logistics was for small
              businesses and everyday people. We built InGo to change that and
              give everyone access to fast affordable services
            </p>
            <p>
              Today InGo operates across 3 cities connecting thousands of
              customers with local drivers and shop owners every single day
            </p>
            <div className="timeline">
              {aboutTimeline.map(([year, text]) => (
                <div className="timeline-item" key={`${year}-${text}`}>
                  <span />
                  <div>
                    <strong>{year}</strong>
                    <p>{text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="story-photo">
            <img
              className="photo-placeholder"
              src="https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&w=900&q=80"
              alt="InGo founders and operations team"
            />
            <div className="customer-float">
              <strong>5,000+</strong>
              <small>Happy Customers</small>
            </div>
          </div>
        </section>

        <section className="mission-values section section-reveal">
          <div className="section-heading">
            <span>WHO WE ARE</span>
            <h2>Our Mission & Values</h2>
          </div>
          <div className="mission-card">
            <span>“</span>
            <h3>
              To connect every person and business with fast, affordable and
              reliable delivery and transportation services
            </h3>
            <p>Vision: To be Africa's most trusted logistics and mobility platform</p>
          </div>
          <div className="values-grid">
            {values.map(([icon, title, copy]) => (
              <article className="value-card" key={title}>
                <span>{icon}</span>
                <h3>{title}</h3>
                <p>{copy}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="about-stats section-reveal" aria-label="About InGo stats">
          {[
            ['5,000+', 'Happy Customers'],
            ['250+', 'Verified Drivers'],
            ['80+', 'Partner Shops'],
            ['3+', 'Cities Covered'],
          ].map(([value, label]) => (
            <div className="stat" key={label}>
              <strong>{value}</strong>
              <span>{label}</span>
            </div>
          ))}
        </section>

        <section id="about-cta" className="about-cta section-reveal">
          <h2>Ready to Experience InGo?</h2>
          <p>Join thousands of happy customers already using InGo</p>
          <a className="btn btn-primary btn-large" href="#download">Download the App</a>
          <a href="/?page=contact">Or contact our team</a>
        </section>
      </main>

      <SiteFooter />
    </div>
  );
}

function ContactPage() {
  return (
    <div className="ingo-site">
      <SiteNav activePage="Contact" actionHref="#contact-form" />

      <main className="contact-page">
        <section className="contact-hero services-hero section-reveal">
          <div className="eyebrow-pill">Get In Touch</div>
          <h1>Contact Us</h1>
          <p>
            Have a question, feedback or partnership inquiry? We would love to
            hear from you
          </p>
          <div className="breadcrumb">
            <a href="/">Home</a>
            <span>›</span>
            <span>Contact Us</span>
          </div>
        </section>

        <section className="contact-main section section-reveal">
          <form id="contact-form" className="contact-form">
            <h2>Send Us a Message</h2>
            <p>We reply within 24 hours</p>
            <div className="inquiry-pills">
              {['General', 'Support', 'Partnership', 'Driver Inquiry', 'Shop Inquiry'].map(
                (type, index) => (
                  <button className={index === 0 ? 'selected' : ''} type="button" key={type}>
                    {type}
                  </button>
                )
              )}
            </div>
            <input placeholder="Full Name" aria-label="Full Name" />
            <input placeholder="Email Address" aria-label="Email Address" type="email" />
            <input placeholder="Phone Number (optional)" aria-label="Phone Number" />
            <input placeholder="Subject" aria-label="Subject" />
            <textarea rows="6" maxLength="500" placeholder="Tell us how we can help you..." />
            <small className="char-count">0 / 500</small>
            <label className="file-box">
              <input type="file" />
              <span>Attach a file (optional)</span>
            </label>
            <button className="btn btn-primary btn-large" type="submit">Send Message</button>
            <small>
              By sending you agree to our <a href="#privacy">Privacy Policy</a>
            </small>
          </form>

          <aside className="contact-info">
            <h2>Other Ways to Reach Us</h2>
            <div className="contact-card-list">
              {contactCards.map(([icon, title, primary, secondary, action]) => (
                <article className="contact-card" key={title}>
                  <span>{icon}</span>
                  <div>
                    <h3>{title}</h3>
                    <p>{primary}</p>
                    <small>{secondary}</small>
                    <a href="#contact-form">{action}</a>
                  </div>
                </article>
              ))}
            </div>
            <div className="follow-row">
              <span>Follow us:</span>
              {['f', 'ig', 'x', 'in'].map((social) => (
                <a href="#contact-form" key={social} aria-label={social}>{social}</a>
              ))}
            </div>
          </aside>
        </section>

        <section className="contact-faq section section-reveal">
          <div className="section-heading">
            <span>FAQ</span>
            <h2>Common Questions</h2>
          </div>
          <div className="faq-columns">
            {[contactFaqs.slice(0, 4), contactFaqs.slice(4)].map((group, groupIndex) => (
              <div className="faq" key={groupIndex}>
                {group.map(([question, answer], index) => (
                  <details key={question} open={groupIndex === 0 && index === 0}>
                    <summary>
                      {question}
                      <span>+</span>
                    </summary>
                    <p>{answer}</p>
                  </details>
                ))}
              </div>
            ))}
          </div>
          <div className="still-help">
            <p>Still need help?</p>
            <a className="btn btn-primary" href="#contact-form">Contact Support</a>
          </div>
        </section>
      </main>

      <SiteFooter />
    </div>
  );
}

function SiteFooter() {
  const footerLinks = [
    [
      'Explore',
      [
        ['Home', '/'],
        ['Services', '/?page=services'],
      ],
    ],
    [
      'Company',
      [
        ['About Us', '/?page=about'],
        ['Contact Us', '/?page=contact'],
      ],
    ],
  ];

  return (
    <footer id="contact" className="footer">
      <div className="footer-grid">
        <div>
          <BrandLogo className="footer-logo" />
          <p>Deliver. Ride. Shop.</p>
          <div className="socials">
            {['f', 'ig', 'x', 'in'].map((social) => (
              <a href="/?page=contact" key={social} aria-label={social}>{social}</a>
            ))}
          </div>
        </div>
        {footerLinks.map(([heading, links]) => (
          <div className="footer-column" key={heading}>
            <h3>{heading}</h3>
            {links.map(([label, href]) => (
              <a href={href} key={label}>
                {label}
              </a>
            ))}
          </div>
        ))}
      </div>
      <div className="footer-bottom">
        <span>© 2026 InGo. All rights reserved</span>
        <span>Made with ❤️ in Africa</span>
      </div>
    </footer>
  );
}

function App() {
  const page = new URLSearchParams(window.location.search).get('page');
  const path = page ? `/${page}` : window.location.pathname.replace(/\/$/, '') || '/';

  if (path === '/services') {
    return <ServicesPage />;
  }

  if (path === '/about') {
    return <AboutPage />;
  }

  if (path === '/contact') {
    return <ContactPage />;
  }

  return (
    <div className="ingo-site">
      <SiteNav />

      <main>
        <section id="home" className="hero section-reveal">
          <span className="blob blob-one" />
          <span className="blob blob-two" />
          <div className="hero-content">
            <div className="eyebrow-pill">🚀 Now available in your city</div>
            <h1>
              Deliver. Ride. Shop.
              <span>All in <strong>One App.</strong></span>
            </h1>
            <p>
              Fast deliveries, affordable rides and local shopping delivered
              straight to your door
            </p>
            <div className="cta-row">
              <a className="btn btn-primary btn-large" href="#download">
                Get Started
              </a>
              <a className="btn btn-outline-blue btn-large" href="/?page=services">
                Learn More <span aria-hidden="true">→</span>
              </a>
            </div>
            <div className="hero-downloads">
              <DownloadBadge store="Google Play" />
              <DownloadBadge store="App Store" />
            </div>
          </div>

          <div className="hero-visual">
            <PhoneMockup />
            <div className="floating-card card-delivery">
              <span>⚡</span>
              <div>
                <strong>Fast Delivery</strong>
                <small>Under 45 mins</small>
              </div>
            </div>
            <div className="floating-card card-rating">
              <span>★</span>
              <div>
                <strong>4.8 Rating</strong>
                <small>5k+ happy users</small>
              </div>
            </div>
            <div className="floating-card card-tracking">
              <span>📍</span>
              <div>
                <strong>Live Tracking</strong>
                <small>Real-time updates</small>
              </div>
            </div>
          </div>
        </section>

        <section className="stats-banner section-reveal" aria-label="InGo statistics">
          {[
            ['5,000+', 'Happy Customers'],
            ['250+', 'Active Drivers'],
            ['10,000+', 'Deliveries Completed'],
            ['3+', 'Cities Covered'],
          ].map(([value, label]) => (
            <div className="stat" key={label}>
              <strong>{value}</strong>
              <span>{label}</span>
            </div>
          ))}
        </section>

        <section id="services" className="section services section-reveal">
          <div className="section-heading">
            <span>WHAT WE OFFER</span>
            <h2>Everything You Need</h2>
            <p>One app for all your delivery, ride and shopping needs</p>
          </div>
          <div className="service-grid">
            {services.map((service) => (
              <article
                className={`service-card ${service.popular ? 'popular' : ''}`}
                key={service.title}
              >
                {service.popular && <span className="popular-badge">Most Popular</span>}
                <div className="icon-circle">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <ul>
                  {service.features.map((feature) => (
                    <li key={feature}>✓ {feature}</li>
                  ))}
                </ul>
                <a href="/?page=services">Learn More <span aria-hidden="true">→</span></a>
              </article>
            ))}
          </div>
        </section>

        <section id="about" className="section how-it-works section-reveal">
          <div className="section-heading">
            <span>HOW IT WORKS</span>
            <h2>Order in 3 Simple Steps</h2>
          </div>
          <div className="steps">
            {[
              ['01', '📍', 'Enter Your Location', 'Set your pickup and drop-off location on the map'],
              ['02', '✓', 'Choose Your Service', 'Select delivery, ride or shop from nearby stores'],
              ['03', '🚚', 'Track in Real Time', 'Watch your order live on the map until it arrives'],
            ].map(([number, icon, title, copy]) => (
              <article className="step" key={number}>
                <div className="step-circle">
                  <strong>{number}</strong>
                  <span>{icon}</span>
                </div>
                <h3>{title}</h3>
                <p>{copy}</p>
              </article>
            ))}
          </div>
          <a className="btn btn-primary btn-large centered-btn" href="#download">
            Get Started Now
          </a>
        </section>

        <section className="section app-showcase section-reveal">
          <div className="phone-pair">
            <PhoneMockup
              variant="tracking"
              screenSrc={PHONE_SCREEN_HOME_URL}
              screenAlt="InGo app home screen"
            />
            <PhoneMockup
              variant="services"
              screenSrc={PHONE_SCREEN_SHOPS_URL}
              screenAlt="InGo app shops screen"
            />
          </div>
          <div className="showcase-copy">
            <span className="section-kicker">THE INGO APP</span>
            <h2>Built for Speed and Simplicity</h2>
            <p>
              InGo keeps every order simple from pickup to drop-off, with clear
              tracking, fast alerts and flexible payments built into one clean app.
            </p>
            <div className="feature-list">
              {appFeatures.map(([title, copy]) => (
                <div className="feature-row" key={title}>
                  <span>✓</span>
                  <div>
                    <strong>{title}</strong>
                    <small>{copy}</small>
                  </div>
                </div>
              ))}
            </div>
            <div className="download-row">
              <DownloadBadge store="Google Play" />
              <DownloadBadge store="App Store" />
            </div>
          </div>
        </section>

        <section className="section business section-reveal">
          <div className="business-grid">
            {[
              [
                '🏪',
                'Shop Owners',
                'List your shop on InGo and reach thousands of customers in your city',
                ['Free shop listing', 'Delivery handled by us', 'Real-time order dashboard', 'Weekly payouts'],
                'Register Your Shop',
              ],
              [
                '🏍️',
                'Become a Driver',
                'Earn money on your schedule. Deliver packages and take rides across the city',
                ['Flexible working hours', 'Daily earnings', 'Navigation assistance', 'Driver support team'],
                'Join as Driver',
              ],
            ].map(([icon, title, copy, benefits, action]) => (
              <article className="business-card" key={title}>
                <div className="business-icon">{icon}</div>
                <h3>{title}</h3>
                <p>{copy}</p>
                <ul>
                  {benefits.map((benefit) => (
                    <li key={benefit}>✓ {benefit}</li>
                  ))}
                </ul>
                <a className="btn btn-primary" href="#contact">
                  {action}
                </a>
              </article>
            ))}
          </div>
        </section>

        <section className="section testimonials section-reveal">
          <div className="section-heading">
            <span>WHAT PEOPLE SAY</span>
            <h2>Loved by Thousands</h2>
          </div>
          <div className="testimonial-grid">
            {testimonials.map((testimonial) => (
              <article
                className={`testimonial-card ${testimonial.featured ? 'featured' : ''}`}
                key={testimonial.name}
              >
                <div className="stars">★★★★★</div>
                <p>"{testimonial.quote}"</p>
                <div className="person">
                  <span className="avatar">{testimonial.name.charAt(0)}</span>
                  <div>
                    <strong>{testimonial.name}</strong>
                    <small>{testimonial.role}</small>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section id="download" className="download-section section-reveal">
          <h2>Download InGo Today</h2>
          <p>Available on Android and iOS. Start your first delivery free</p>
          <div className="download-buttons">
            <DownloadBadge store="Google Play" />
            <DownloadBadge store="App Store" />
          </div>
        </section>
      </main>

      <SiteFooter />
    </div>
  );
}

export default App;
